module.exports = __webpack_public_path__ + "Iconmetro-file-pdf.png";